import { useFormik } from "formik";
import { adminCreateInfo, adminUploadImage } from "helpers/backend_helpers";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { toast } from "react-toastify";
import {
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import "../../index.css";
import "../../pages/Info/style.css";

const AddModalInfo = ({ show, onCloseClick, getData }: any) => {
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      image: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Nama harus diisi!"),
      image: Yup.string(),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      setIsSuccess(false);

      if (imageFile) {
        const formData = new FormData();
        formData.append("image", imageFile);

        try {
          const response: any = await adminUploadImage(formData, {
            feature: "info",
          });
          values.image = response;
        } catch (error) {
          setIsLoading(false);
          toast.error("Gagal mengunggah gambar");
          return;
        }
      }

      adminCreateInfo(values)
        .then((response: any) => {
          setIsSuccess(true);
          toast.success(
            <div>
              Info <b>{values.name}</b> berhasil ditambahkan!
            </div>,
            { autoClose: 5000 }
          );
          validation.resetForm();
          setTimeout(() => {
            onCloseClick();
            getData();
            setIsSuccess(false);
          }, 2000);
        })
        .catch(() => {
          setIsLoading(false);
        })
        .finally(() => {});
    },
  });

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    if (!file) return;

    setImageFile(file);

    const reader = new FileReader();
    reader.onload = (e: any) => {
      setSelectedImage(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    if (!show) {
      validation.resetForm();
      setSelectedImage(null);
      setImageFile(null);
      setIsLoading(false);
      setIsSuccess(false);
    }
  }, [show]);

  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={isLoading ? undefined : onCloseClick}
      centered={true}
      keyboard={false}
      backdrop={isLoading ? "static" : true}
    >
      <ModalHeader
        className="bg-light p-3"
        toggle={isLoading ? undefined : onCloseClick}
      >
        Tambah Info
      </ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody>
          {isSuccess ? (
            <div className="text-center py-4">
              <div className="mb-3">
                <i
                  className="ri-checkbox-circle-line text-success"
                  style={{ fontSize: "4rem" }}
                ></i>
              </div>
              <h5 className="text-success mb-3">Data Berhasil Ditambahkan!</h5>
              <p className="text-muted">Modal akan tertutup otomatis...</p>
              <Spinner color="success" size="sm" className="mt-2" />
            </div>
          ) : (
            <>
              <div className="mb-3">
                <Label htmlFor="name" className="form-label">
                  Nama <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Masukkan nama"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.name || ""}
                  invalid={
                    validation.touched.name && validation.errors.name
                      ? true
                      : false
                  }
                  disabled={isLoading}
                />
                {validation.errors.name && validation.touched.name ? (
                  <FormFeedback type="invalid">
                    {validation.errors.name}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3">
                <Label htmlFor="gambar" className="form-label">
                  Gambar
                </Label>
                <div className="text-left">
                  <div className="position-relative d-inline-block">
                    <div className="position-absolute top-100 start-100 translate-middle">
                      <Label
                        htmlFor="customer-image-input"
                        className="mb-0"
                        data-bs-toggle="tooltip"
                        data-bs-placement="right"
                        title="Pilih Gambar"
                      >
                        <div
                          className={`avatar-xs ${
                            isLoading ? "" : "cursor-pointer"
                          }`}
                        >
                          <div className="avatar-title bg-light border rounded-circle text-muted">
                            <i className="ri-image-fill"></i>
                          </div>
                        </div>
                      </Label>
                      <Input
                        className="form-control d-none"
                        id="customer-image-input"
                        type="file"
                        accept="image/png, image/gif, image/jpeg"
                        onChange={handleImageChange}
                        disabled={isLoading}
                      />
                    </div>
                    <div className="avatar-xl">
                      <div className="avatar-title bg-light rounded">
                        <Zoom>
                          <img
                            src={
                              selectedImage ||
                              "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
                            }
                            id="product-img"
                            alt=""
                            className="avatar-xl h-auto"
                            style={{
                              cursor: isLoading ? "default" : "zoom-in",
                            }}
                          />
                        </Zoom>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </ModalBody>
        {!isSuccess && (
          <ModalFooter>
            <button
              type="button"
              className="btn btn-soft-danger waves-effect waves-light material-shadow-none btn-sm"
              data-bs-dismiss="modal"
              onClick={onCloseClick}
              disabled={isLoading}
            >
              Batal
            </button>
            <button
              type="submit"
              className="btn btn-soft-success waves-effect waves-light material-shadow-none btn-sm"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Spinner size="sm" className="me-1" />
                  Menyimpan...
                </>
              ) : (
                "Tambah"
              )}
            </button>
          </ModalFooter>
        )}
      </Form>
    </Modal>
  );
};

AddModalInfo.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  getData: PropTypes.func,
};

export default AddModalInfo;
